module.exports = __webpack_public_path__ + "static/click_18-500a0148a5a8f3d33415e93cfe384c00.wav";